<template>
  <div>
    <TableApp
      ref="tabela"
      titulo="Clientes e contatos"
      api-url="/crm/contatos/lista"
      :fields="fields"
    >
      <template #toolbar-actions>
        <button
          class="btn btn-dark font-weight-bolder font-size-sm"
          @click="abrirModal"
        >
          Novo contato
        </button>
      </template>
    </TableApp>

    <b-modal
      id="crm-contato-modal"
      title="Novo contato"
      ok-title="Salvar"
      cancel-title="Cancelar"
      @ok.prevent="salvar"
    >
      <b-form-group label="Nome">
        <b-form-input v-model="form.nome" />
      </b-form-group>
      <b-form-group label="WhatsApp">
        <b-form-input
          v-model="form.telefone"
          placeholder="Telefone com DDD"
          type="tel"
        />
      </b-form-group>
      <b-form-group label="E-mail">
        <b-form-input v-model="form.email" />
      </b-form-group>
      <b-form-group label="Observações">
        <b-form-textarea v-model="form.observacoes" rows="3" />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import TableApp from "@/components/Table/Table2";
import crmService from "@/modules/CRM/services/crmService";

export default {
  name: "crm-contatos",
  components: { TableApp },
  data() {
    return {
      form: this.emptyForm(),
      fields: [
        { label: "Nome", field: "nome", filterOptions: { enabled: true } },
        {
          label: "Telefone",
          field: "telefone",
          filterOptions: { enabled: true },
        },
        { label: "E-mail", field: "email", filterOptions: { enabled: true } },
        { label: "Status", field: "status", filterOptions: { enabled: true } },
        { label: "Responsável", field: "usuario" },
      ],
    };
  },
  methods: {
    emptyForm() {
      return {
        nome: "",
        telefone: "",
        email: "",
        observacoes: "",
      };
    },
    abrirModal() {
      this.form = this.emptyForm();
      this.$bvModal.show("crm-contato-modal");
    },
    async salvar() {
      await crmService.criarContato(this.form);
      this.$toast.success("Contato criado com sucesso.");
      this.$bvModal.hide("crm-contato-modal");
      this.$refs.tabela.refresh();
    },
  },
};
</script>
